exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#btn-dropdown-themeSelection {\n  background-color: #1594A6;\n  display: block; }\n\n.theme-label {\n  font-size: 1rem; }\n\n.dependency-button {\n  margin-top: 20px; }\n\n.chips {\n  padding: 15px; }\n\n.attachmentsButton {\n  color: #9c9b99; }\n\n.attachmentsButton:hover {\n  color: #76797E; }\n\n.chip {\n  font-size: 1rem; }\n\n.chip:hover {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/edit-epic-detail-dialog/edit-epic-detail-dialog.component.scss
// module id = ../../../../../src/app/components/edit-epic-detail-dialog/edit-epic-detail-dialog.component.scss
// module chunks = main